DW.LoadingTransitions = function(initOnLoadObjects) {
	this.loaded = false;
	this.unload = true;
	this.exceptionFromUnloadHrefs = [
		'mailto:',
		'tel:'
	];
	this.timoutLoad = null;

	// All objects that need some logic to happen on load
	this.initOnLoadObjects = initOnLoadObjects;

  // unload event get's also called by mail, tel, etc. Links and should be stopped for those
  this.exceptionFromUnloadHrefs = [
    'mailto:',
    'tel:'
  ];

	// Indicate loading, either on window.load or after 2500ms
	timeoutLoad = setTimeout(this.loadContent.bind(this), 2500);
	window.addEventListener('load', this.loadContent.bind(this));

	// add Unload Event Listener
	window.addEventListener('beforeunload', this.unloadContent.bind(this));

  // exception Listener
	document.addEventListener('click', this.checkIfUnloadShouldHappen.bind(this));
};

DW.LoadingTransitions.prototype = {
	loadContent: function() {

		// this should happen only once
		clearTimeout(this.timeoutLoad);
		if(this.loaded === false) {
			this.loaded = true;
			document.body.classList.add("loaded");

			// Tell objects, load has happened
			setTimeout(function() {
				this.initOnLoadObjects.forEach(function(initOnLoadObject) {
					initOnLoadObject.initOnLoad();
				});
			}.bind(this), 300);
		}
	},

	unloadContent: function() {
		if(this.unload === true) {
			document.body.classList.add("unload");
		}

		// Reset unload
		unload = true;
	},

  checkIfUnloadShouldHappen: function(ev) {
    
    // Check if unload should be canceled for link
		if(typeof ev.target.href !== 'undefined') {
			this.exceptionFromUnloadHrefs.forEach(function(exceptionFromUnloadHref) {
				if(ev.target.href.indexOf(exceptionFromUnloadHref) >= 0) {
					this.unload = false;
				}
			}.bind(this));
		}
  }
};
